import { SlideInPortalId } from '../../account/root/components/PortalSlidein.tsx';
import { css } from '@emotion/css';
import { ResponsiveProperties } from '../../layout/utils/ResponsiveProperties.ts';
import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { Colors } from 'dg-web-shared/ui/vars.ts';
import * as LayoutState from '../../layout/state/LayoutState.ts';
import { Modal } from '../../common/components/Modal.tsx';
import { Spinner } from 'dg-web-shared/ui/Spinner.tsx';
import { useState, useEffect } from 'react';

export const SpinnerModal = (p: {
    visible: boolean;
    portal: SlideInPortalId;
}) => {
    if (!p.visible) {
        return null;
    }
    return (
        <Modal portal={p.portal}>
            <EasingInSpinner />
        </Modal>
    );
};

function EasingInSpinner() {
    const [didMount, setDidMount] = useState(false);

    useEffect(() => {
        const delayId = window.setTimeout(() => setDidMount(true), 350);
        return () => window.clearTimeout(delayId);
    }, []);

    return (
        <div
            className={css({
                background: Colors.white,
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                zIndex: 1000,
                position: 'absolute',
                opacity: didMount ? 0.66 : 0,
                transition: 'opacity 200ms ease-in',
            })}
        >
            {didMount && <Spinner centerVertically />}
        </div>
    );
}

export function EmptyBackground({
    hasRunningTransaction,
}: {
    hasRunningTransaction?: boolean;
}) {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));
    const blueSpinnerBackground =
        new ResponsiveProperties(storeState).mobile && !hasRunningTransaction;
    return (
        <div
            className={css({
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                background: blueSpinnerBackground ? Colors.blue : Colors.white,
            })}
        />
    );
}
